const $ = jQuery;

class VueLoader {
    
    constructor(components){
        
        // save our component definitions
        this.components = components;

        if (window.MutationObserver) {
            const observer = new MutationObserver(() => this.parse());
            observer.observe(document.documentElement, {
                childList: true,
                subtree: true
            });
        }
        $(()=>this.parse());
    }

    parse(){
        const $components = $('[data-vue-component]');
        
        $components.each( async (i, el) => {

            const name = $(el).data('vue-component');
            $(el).attr('data-vue-component', null);

            if (!this.components[name]) {
                return;
            }
            const config = $(el).data('vue-config');

            const Vue = await import('vue');
            const component = await this.components[name];

            const v = new Vue.default({
                el: el,
                render: function (h) {
                    return h(component.default, {
                        props: config || {}
                    });
                }
            });

            $(v.$el).data('vue', v.$children[0]);
        });
    }
}

export default VueLoader;